/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlogCategoryDto } from '../models/BlogCategoryDto';
import type { BlogCategoryInputDto } from '../models/BlogCategoryInputDto';
import type { BlogDecoratedTextDto } from '../models/BlogDecoratedTextDto';
import type { BlogDto } from '../models/BlogDto';
import type { BlogDtoPagedListData } from '../models/BlogDtoPagedListData';
import type { BlogHeadingDto } from '../models/BlogHeadingDto';
import type { BlogInput } from '../models/BlogInput';
import type { BlogListItemDto } from '../models/BlogListItemDto';
import type { BlogQuoteDto } from '../models/BlogQuoteDto';
import type { BlogSectionDto } from '../models/BlogSectionDto';
import type { BlogsImageDto } from '../models/BlogsImageDto';
import type { BlogTextParagraphDto } from '../models/BlogTextParagraphDto';
import type { BlogVisibleInput } from '../models/BlogVisibleInput';
import type { BlogYoutubeVideoDto } from '../models/BlogYoutubeVideoDto';
import type { BlogMoveInput } from '../models/ContentLogMoveDir';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { BlogCopyInput } from '../models/BlogCopyInput';

export class BlogService {

  /**
   * Get paged list of blogs
   * @param article 
   * @param isPublish 
   * @param category 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns BlogDtoPagedListData Success
   * @throws ApiError
   */
  public static getBlogs(
article?: string,
isPublish?: boolean,
category?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<BlogDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/blogs',
      query: {
        'Article': article,
        'IsPublish': isPublish,
        'Category': category,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * Create blog
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogs(
requestBody?: BlogInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Get blog by url code
   * @param code 
   * @returns BlogDto Success
   * @throws ApiError
   */
  public static getBlogsByCode(
code?: string,
): CancelablePromise<BlogDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/blogs/by-code',
      query: {
        'code': code,
      },
    });
  }


  /**
   * Copy blog with sections
   * @param id 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsCopy(
    id: number,
    requestBody?: BlogCopyInput,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/blogs/{id}/copy',
          path: {
            'id': id,
          },
          body: requestBody,
          mediaType: 'application/json-patch+json',
        });
      }

  /**
   * Update blog
   * @param id Blog id
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogs(
id: number,
requestBody?: BlogInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Delete blog
   * @param id Blog id
   * @returns any Success
   * @throws ApiError
   */
  public static deleteBlogs(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/blogs/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Change publish status (publish/draft)
   * @param id Blog id
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsPublish(
id: number,
requestBody: {
  isPublished: boolean,
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{id}/publish',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Upload file
   * @param formData 
   * @returns string Created
   * @throws ApiError
   */
  public static postBlogsFiles(
formData?: {
File: Blob;
},
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/files',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Get list of categories
   * @returns BlogCategoryDto Success
   * @throws ApiError
   */
  public static getBlogsCategories(): CancelablePromise<Array<BlogCategoryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/blogs/categories',
    });
  }

  /**
   * Create category
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsCategories(
requestBody?: BlogCategoryInputDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/categories',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Update category
   * @param id Category id
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsCategories(
id: number,
requestBody?: BlogCategoryInputDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/categories/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Delete category
   * @param id Category id
   * @returns any Success
   * @throws ApiError
   */
  public static deleteBlogsCategories(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/blogs/categories/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Move section up/down
   * @param blogId 
   * @param sectionId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsSectionsMove(
blogId: number,
sectionId: number,
requestBody?: BlogMoveInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{blogId}/sections/{sectionId}/move',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Set section visibility
   * @param blogId 
   * @param sectionId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsSectionsIsVisible(
blogId: number,
sectionId: number,
requestBody?: BlogVisibleInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{blogId}/sections/{sectionId}/is-visible',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Delete section
   * @param blogId 
   * @param sectionId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteBlogsSections(
blogId: number,
sectionId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/blogs/{blogId}/sections/{sectionId}',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
    });
  }

  /**
   * Get sections
   * @param blogId 
   * @returns BlogSectionDto Success
   * @throws ApiError
   */
  public static getBlogsSections(
blogId: number,
): CancelablePromise<Array<BlogSectionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/blogs/{blogId}/sections',
      path: {
        'blogId': blogId,
      },
    });
  }

  /**
   * Create Table of contents section
   * @param blogId 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsSectionsTableOfContents(
blogId: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/{blogId}/sections/table-of-contents',
      path: {
        'blogId': blogId,
      },
    });
  }

  /**
   * Create Heading section
   * @param blogId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsSectionsHeadings(
blogId: number,
requestBody?: BlogHeadingDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/{blogId}/sections/headings',
      path: {
        'blogId': blogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Update Heading section
   * @param blogId 
   * @param sectionId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsSectionsHeadings(
blogId: number,
sectionId: number,
requestBody?: BlogHeadingDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{blogId}/sections/{sectionId}/headings',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Create Text paragraph section
   * @param blogId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsSectionsTextParagraphs(
blogId: number,
requestBody?: BlogTextParagraphDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/{blogId}/sections/text-paragraphs',
      path: {
        'blogId': blogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Update Text paragraph section
   * @param blogId 
   * @param sectionId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsSectionsTextParagraphs(
blogId: number,
sectionId: number,
requestBody?: BlogTextParagraphDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{blogId}/sections/{sectionId}/text-paragraphs',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Create Quote section
   * @param blogId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsSectionsQuotes(
blogId: number,
requestBody?: BlogQuoteDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/{blogId}/sections/quotes',
      path: {
        'blogId': blogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Update Quote section
   * @param blogId 
   * @param sectionId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsSectionsQuotes(
blogId: number,
sectionId: number,
requestBody?: BlogQuoteDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{blogId}/sections/{sectionId}/quotes',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Create List section
   * @param blogId 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsSectionsLists(
blogId: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/{blogId}/sections/lists',
      path: {
        'blogId': blogId,
      },
    });
  }

  /**
   * Create List item
   * @param blogId 
   * @param sectionId 
   * @param requestBody 
   * @returns string Created
   * @throws ApiError
   */
  public static postBlogsSectionsListsItems(
blogId: number,
sectionId: number,
requestBody?: BlogListItemDto,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/{blogId}/sections/lists/{sectionId}/items',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Update List item
   * @param blogId 
   * @param sectionId 
   * @param itemId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsSectionsListsItems(
blogId: number,
sectionId: number,
itemId: number,
requestBody?: BlogListItemDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{blogId}/sections/lists/{sectionId}/items/{itemId}',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Delete List item
   * @param blogId 
   * @param sectionId 
   * @param itemId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteBlogsSectionsListsItems(
blogId: number,
sectionId: number,
itemId: number,
requestBody?: BlogListItemDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/blogs/{blogId}/sections/lists/{sectionId}/items/{itemId}',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Create Decorated text section
   * @param blogId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsSectionsDecoratedTexts(
blogId: number,
requestBody?: BlogDecoratedTextDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/{blogId}/sections/decorated-texts',
      path: {
        'blogId': blogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Update Decorated text section
   * @param blogId 
   * @param sectionId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsSectionsDecoratedTexts(
blogId: number,
sectionId: number,
requestBody?: BlogDecoratedTextDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{blogId}/sections/{sectionId}/decorated-texts',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Create Image section
   * @param blogId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsSectionsImages(
blogId: number,
requestBody?: BlogsImageDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/{blogId}/sections/images',
      path: {
        'blogId': blogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Update Image section
   * @param blogId 
   * @param sectionId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsSectionsImages(
blogId: number,
sectionId: number,
requestBody?: BlogsImageDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{blogId}/sections/{sectionId}/images',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Create Youtube video section
   * @param blogId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBlogsSectionsYoutubeVideos(
blogId: number,
requestBody?: BlogYoutubeVideoDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/blogs/{blogId}/sections/youtube-videos',
      path: {
        'blogId': blogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Update Youtube video section
   * @param blogId 
   * @param sectionId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBlogsSectionsYoutubeVideos(
blogId: number,
sectionId: number,
requestBody?: BlogYoutubeVideoDto,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/blogs/{blogId}/sections/{sectionId}/youtube-videos',
      path: {
        'blogId': blogId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
